import React from "react";
import { Quote } from "lucide-react";
import Reveal from "./Reveal";
import { MEDIA_IMGS } from "./data";
import { useT } from "./i18n";

// Clearly-labelled placeholders. No invented names, employers or statistics.
const IMGS = [MEDIA_IMGS[0], MEDIA_IMGS[1], MEDIA_IMGS[4]];

export default function Stories() {
  const { t } = useT();
  return (
    <section className="bg-[#FDFBF7] py-20">
      <div className="mx-auto max-w-6xl px-5">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.22em] text-[#C4A46B]">{t.stories.eyebrow}</p>
          <h2 className="mt-3 max-w-2xl font-serif text-4xl leading-tight text-[#173A2C] sm:text-5xl">{t.stories.heading}</h2>
          <p className="mt-3 max-w-2xl text-base text-[#5C5855]">{t.stories.sub}</p>
        </Reveal>
        <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {IMGS.map((img, i) => (
            <Reveal key={i} delay={(i % 3) + 1} className="group relative h-80 overflow-hidden rounded-2xl border border-[#E8E4DB]">
              <img src={img} alt="" loading="lazy" decoding="async" className="img-zoom h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[#173A2C]/85 via-[#173A2C]/20 to-transparent" />
              <span className="absolute left-4 top-4 rounded-full border border-white/40 bg-black/25 px-3 py-1 text-[11px] font-medium text-white backdrop-blur">
                {t.stories.placeholder} · {t.stories.roles[i]}
              </span>
              <div className="absolute bottom-5 left-5 right-5 text-white">
                <Quote className="h-6 w-6 text-[#C4A46B]" />
                <p className="mt-2 text-sm text-white/85">{t.stories.quote}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
